export const socialLinks = [
	{
		id: 1,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/dinsuprano',
	},
	{
		id: 3,
		name: 'Twitter',
		icon: 'twitter',
		url: 'https://twitter.com/nuruddinnnaim',
	},
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/nuruddin-naim/',
	},
	{
		id: 5,
		name: 'Email',
		icon: 'mail',
		url: 'mailto:nuruddinnaim@gmail.com',
	},
];
